import clsx from 'clsx';
import { ReactSVG } from 'react-svg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

import arrowIcon from '@/assets/icons/form-and-reviews/arrow.svg';

import styles from './Carousel.module.scss';

interface CarouselProps {
  className?: string;
  theme?: 'light' | 'dark' | 'transparent';
  id: string;
  slidesPerView?: number;
  spaceBetweenSlides?: number;
  slides: React.ReactNode[];
}

export function Carousel({
  className,
  theme,
  id,
  slidesPerView,
  spaceBetweenSlides,
  slides,
}: CarouselProps) {
  return (
    <div
      className={clsx(
        styles.carousel,
        {
          [styles.carousel_dark]: theme === 'dark',
          [styles.carousel_transparent]: theme === 'transparent',
        },
        className,
      )}
      id={id}
    >
      <button className={styles.carousel__prev} aria-label="Carousel previous" id={`${id}-prev`}>
        <ReactSVG className={styles.carousel__arrow} src={arrowIcon} />
      </button>
      <Swiper
        className={styles.carousel__swiper}
        modules={[Navigation]}
        navigation={{
          prevEl: `#${id}-prev`,
          nextEl: `#${id}-next`,
        }}
        slidesPerView={slidesPerView || 1}
        spaceBetween={spaceBetweenSlides || 0}
        loop={true}
        speed={600}
      >
        {slides.map((slide, index) => (
          <SwiperSlide className={styles.carousel__swiperSlide} key={index}>
            {slide}
          </SwiperSlide>
        ))}
      </Swiper>
      <button className={styles.carousel__next} aria-label="Carousel next" id={`${id}-next`}>
        <ReactSVG className={styles.carousel__arrow} src={arrowIcon} />
      </button>
    </div>
  );
}
